<template>
	<header :id="id" class="bmed-component header w-full px-5 py-5 md:py-10">
		<div class="logo m-auto">
			<UiLogo @click="console.log('analytics')"/>
		</div>
	</header>
</template>

<script>
import UiLogo from '@/components/ui/Logo'

export default {
	name: 'PageHeader',
	props: {
		id: {
			type: String,
			default: 'pageHeader'
		}
	},
	components: {
		UiLogo
	}
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_config.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/animations.css"></style>
<style src="@/assets/css/main.css"></style>

<style scoped>
.logo {
	width: 60%;
	max-width: var(--logo-width-lg); 
}
</style>